var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-name-wrapper"},[(_vm.dataName)?_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.dataName.fname)+" "+_vm._s(_vm.dataName.middle_name)+" "+_vm._s(_vm.dataName.lname))]):_vm._e(),(_vm.dataName)?_c('span',{staticClass:"email"},[_vm._v("@"+_vm._s(_vm.dataName.user_link))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }